import { http } from '../client';
import type { CallOptions, WriteOptions } from '../types';
import type { NotifyApi } from './notify';

// Paths mirror subsystems/communications/facade/adapters/admin-api/src/admin/notify.rs.
const seg = encodeURIComponent;
const rd = (o?: CallOptions) => ({ signal: o?.signal });
const wr = (o?: WriteOptions) => ({ signal: o?.signal, idempotencyKey: o?.idempotencyKey, notifyCustomer: o?.notifyCustomer });

export const notifyHttp: NotifyApi = {
  getEmailSettings: (owner, opts) => http.get('api', `/notify/settings/${seg(owner)}`, rd(opts)),
  saveEmailSettings: (owner, body, opts) => http.put('api', `/notify/settings/${seg(owner)}`, body, wr(opts)),
  testEmailSettings: (owner, body, opts) => http.post('api', `/notify/settings/${seg(owner)}/test`, body, wr(opts)),
  listEmailTemplates: (owner, opts) => http.get('api', `/notify/templates/${seg(owner)}`, rd(opts)),
  saveEmailTemplate: (owner, key, locale, body, opts) => http.put('api', `/notify/templates/${seg(owner)}/${seg(key)}/${seg(locale)}`, body, wr(opts)),
  revertEmailTemplate: (owner, key, locale, opts) => http.delete('api', `/notify/templates/${seg(owner)}/${seg(key)}/${seg(locale)}`, wr(opts)),
  previewEmailTemplate: (owner, body, opts) => http.post('api', `/notify/preview/${seg(owner)}`, body, rd(opts)),
  listNotifications: (query, opts) => http.get('api', '/notify/notifications', { query: { ...query }, ...rd(opts) }),
  getNotification: (id, opts) => http.get('api', `/notify/notifications/${seg(id)}`, rd(opts)),
  resendNotification: (id, opts) => http.post('api', `/notify/notifications/${seg(id)}/resend`, {}, wr(opts)),
};
